export enum FilterType {
  all = 'all',
  location = 'location',
  installation = 'installation',
  campaign = 'campaign',
  zone = 'zone'
}